import { useEffect, ReactElement } from "react";

import { CognitoUser } from "amazon-cognito-identity-js";
import { useHistory, useLocation } from "react-router-dom";

// NOTE trackingはRouterの機能をつかっているのでRoute以下に入れないといけないので仕込むための空のComponentを用意

const trackingId = process.env.REACT_APP_GA_TRACKING_ID || "";
const isDirectlyTracking = process.env.REACT_APP_GA_TRAKING_USE_HREF || "";
const gaId = "script-import-gtag";
const gtagSrc = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
const gtagScriptText = `
window.dataLayer = window.dataLayer || []
function gtag() { dataLayer.push(arguments) }
gtag('js', new Date())
gtag('config', '${trackingId}')
`;

export const injectGA = (user?: CognitoUser): void => {
  if (!trackingId) {
    // eslint-disable-next-line no-console
    console.debug("GA Tracking is not enabled.");
    return;
  }

  if (document.getElementById(gaId)) {
    // eslint-disable-next-line no-console
    console.debug("already gtag imported");
    return;
  }

  const importScript = document.createElement("script");
  importScript.crossOrigin = "";
  importScript.async = true;
  importScript.id = gaId;
  importScript.src = gtagSrc;
  document.head.appendChild(importScript);

  const gtagScript = document.createElement("script");
  gtagScript.text = gtagScriptText;
  document.head.appendChild(gtagScript);

  if (window.gtag) {
    window.gtag("config", trackingId, { user_id: user?.getUsername() });
  }
};

export const useTracking = (): void => {
  const location = useLocation();
  const { listen } = useHistory();

  useEffect(() => {
    const unlisten = listen((listenLocation) => {
      if (!trackingId || !window.gtag) return;

      window.gtag("config", trackingId, { page_path: listenLocation.pathname });
    });

    return unlisten;
  }, [listen]);

  // NOTE montanaは基本history.pushを使ってないのでリンククリック時にhistoryがうまく効かないので直接設定する
  if (isDirectlyTracking && trackingId && window.gtag) {
    window.gtag("config", trackingId, { page_path: location.pathname });
  }
};

export function GATrackingComponent(): ReactElement | null {
  useTracking();
  return null;
}
